import shortid from 'shortid';
//import uuid from 'uuid/v4';

export function shortId() {
  return shortid();
}